import { Paper, Typography, Stack, Divider, Box } from "@mui/material";

const DashboardCard = ({ title, total, icon: Icon, color, details, onClick }) => {
  return (
    <Paper
      onClick={onClick}
      sx={{
        p: 2.5,
        height: "100%",
        borderRadius: 4,
        cursor: onClick ? "pointer" : "default",
        background: "rgba(255,255,255,0.95)",
        border: "1px solid #e5edf6",
        transition: "all .35s ease",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: `0 25px 45px ${color}33`,
        },
      }}
    >
      <Stack direction="row" justifyContent="space-between" mb={2}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            background: `linear-gradient(135deg, ${color}, ${color}aa)`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon size={22} color="#fff" />
        </Box>

        <Typography variant="h4" fontWeight={700}>
          {total}
        </Typography>
      </Stack>

      <Typography fontWeight={600} mb={1}>
        {title}
      </Typography>

      {Object.keys(details).length > 0 && (
        <>
          <Divider sx={{ mb: 1.5 }} />
          {Object.entries(details).map(([k, v]) =>
            v !== undefined ? (
              <Stack key={k} direction="row" justifyContent="space-between" fontSize={14}>
                <span>{k}</span>
                <strong>{v}</strong>
              </Stack>
            ) : null
          )}
        </>
      )}
    </Paper>
  );
};

export default DashboardCard;
